module.exports = __webpack_public_path__ + "img/works.79b180a2.png";